export const apiConfig = {
	url: process.env.REACT_APP_API_URL,
	// urlMock: process.env.REACT_APP_API_URL_MOCK,
	frontendBaseUrl: process.env.REACT_APP_BASE_URL,
	frontendRegistrationUrl: process.env.REACT_APP_BASE_URL + '/sign-up'
};

export default apiConfig;